import { createContext, useEffect, useReducer, useState} from "react"

const AuthContext = createContext({});

const authReducer = (state,action) => {
    switch (action.type) {
        case "LOGIN":
            return {user : action.payload};
        case "LOGOUT":
            localStorage.removeItem("cthash")
            return {user: null}
        default :
            return state;
    }
}

export const AuthProvider = ({ children }) =>{

    const [state,dispatch] = useReducer(authReducer,{user:null});

    const [loading, setLoading] = useState(true)

    const [ auth ,setAuth] = useState({});
    // const [ isLoggedIn,SetIsLoggedIn ] = useState(false);
    const [ pa,setPa ] = useState("BNBUSDT");

    useEffect(()=>{
        let user = localStorage.getItem("cthash")
        if(user != null){
            dispatch({type:"LOGIN", payload:user})
        }
        setLoading(false)
    },[])

    if(!loading)
    return(
        // <AuthContext.Provider value={{ auth ,setAuth,fees,setFees,val,setVal, order,setOrder,balance, setBalance  }} >
        // <AuthContext.Provider value={{ auth ,setAuth,val,setVal,fees,setFees,pair,setPair }} >
        <AuthContext.Provider value={{ auth, setAuth, pa, setPa,...state,dispatch }} >
            {children}
        </AuthContext.Provider>
    )

}

export default AuthContext;